<template>
  <div class="cm-expand" :aria-expanded="userExpanded">
    <div
      v-show="matchesMediaQuery"
      class="cm-expand__header"
      @click="toggleExpansion"
    >
      <h2 class="cm-expand__header__heading">
        <slot name="header" />
      </h2>

      <button class="cm-expand__header__arrow" type="cm-button" tabindex="0">
        {{userExpanded ? "navigateup" : "navigatedown"}}
      </button>
    </div>

    <div class="cm-expand__expandable-region" v-show="isExpanded">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    media: {
      type: String // eg (min-width: 400px)
    }
  },

  data() {
    return {
      userExpanded: false,

      matchesMediaQuery: false
    };
  },

  mounted() {
    if (this.media) {
      this.checkMediaQuery();
      window.addEventListener("resize", this.checkMediaQuery);
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkMediaQuery);
  },

  computed: {
    isExpanded() {
      return this.matchesMediaQuery ? this.userExpanded : true;
    }
  },

  methods: {
    toggleExpansion() {
      this.userExpanded = !this.userExpanded;
    },

    checkMediaQuery() {
      this.matchesMediaQuery = window.matchMedia(this.media).matches;
    }
  }
};
</script>

<style scoped lang="scss">
.cm-expand {
  &__header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0;
    &__heading {
      @extend %h3;
      margin: 0;
    }
    &__arrow {
      font-family: $ff_icon;
      background: none;
      border: none;
      appearance: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/expand.vue?44203172